<template>
    <div :key="renderKey">
        <!--
        <draggable v-model="rows" :disabled="!$root.edit || rows.length == 1" @change="save">
            <v-row v-for="(row,rowindex) in rows" :key="rowindex" no-gutters> -->
        <!-- <draggable v-model="rows[rowindex]" tag="v-row" :component-data="{props: {'no-gutters': true } }" @change="save" :disabled="!$root.edit"> -->
        <!--                    <v-col v-for="(col,colindex) in row" :key="colindex" :md="col.width" cols=12>
                        <v-row v-if="$root.edit" no-gutters>
                            <v-col v-if="colindex == 0" cols=1 class="ml-4">
                                <v-menu
                                    bottom
                                    left
                                    offset-y
                                    nudge-right="170px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="zoezi-edit-color"
                                            fab
                                            small
                                            v-on="on"
                                            class="ma-2"
                                        >
                                            <v-icon small>mdi-cog</v-icon>
                                            <v-icon small style="margin-left: -8px">mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list active-class="deep-purple">
                                        <v-list-item @click="removeRow(rowindex)" active-class="deep-purple">
                                            <v-list-item-icon>
                                                <v-icon>mdi-delete</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Ta bort rad</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-menu
                                            bottom
                                            right
                                            offset-x
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-list-item v-on="on">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-table-arrow-up</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Lägg till rad ovanför...</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>

                                            <columns-menu v-on:add="addAbove(rowindex, ...arguments)" />
                                        </v-menu>
                                        <v-menu
                                            bottom
                                            right
                                            offset-x
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-list-item v-on="on">
                                                    <v-list-item-icon>
                                                        <v-icon>mdi-table-arrow-down</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Lägg till rad nedanför...</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>

                                            <columns-menu v-on:add="addBelow(rowindex, ...arguments)" />
                                        </v-menu>
                                    </v-list>
                                </v-menu>

                            </v-col>
                            <v-col cols=1 offset=5>
                                <v-btn
                                    class="my-2"
                                    color="zoezi-edit-color"
                                    fab
                                    small
                                    style="visibility: hidden"
                                >
                                    <v-icon>mdi-cog</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols=12>
                                <component-wrapper :config="col" />
                            </v-col>
                        </v-row>
                    </v-col> -->
        <!-- </draggable> -->
        <!--   </v-row>
        </draggable> -->

        <component-wrapper v-for="(row,rowindex) in rows" :key="row.id" :config="row" can-remove :array="rows">
            <template v-slot:bottom-button>
                <v-menu
                    bottom
                    left
                    offset-y
                    nudge-right="170px"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="zoezi-edit-color"
                            fab
                            small
                            v-on="on"
                            class="ma-2"
                        >
                            <v-icon small>mdi-cog</v-icon>
                            <v-icon small style="margin-left: -8px">mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-list active-class="zoezi-edit-color">
                        <v-list-item @click="removeRow(rowindex)" active-class="zoezi-edit-color">
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Delete row')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-menu
                            bottom
                            right
                            offset-x
                        >
                            <template v-slot:activator="{ on }">
                                <v-list-item v-on="on">
                                    <v-list-item-icon>
                                        <v-icon>mdi-table-arrow-up</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{$translate('Add row above...')}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <columns-menu v-on:add="addAbove(rowindex, ...arguments)" />
                        </v-menu>
                        <v-menu
                            bottom
                            right
                            offset-x
                        >
                            <template v-slot:activator="{ on }">
                                <v-list-item v-on="on">
                                    <v-list-item-icon>
                                        <v-icon>mdi-table-arrow-down</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{$translate('Add row below...')}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <columns-menu v-on:add="addBelow(rowindex, ...arguments)" />
                        </v-menu>
                    </v-list>
                </v-menu>
            </template>
        </component-wrapper>

        <v-row v-if="$root.edit" no-gutters class="zoezi-add-rowlayout">
            <v-col cols=12 align="center" justify="center">
                <v-menu
                    bottom
                    right
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="zoezi-edit-color"
                            fab
                            small
                            v-on="on"
                        >
                            <v-icon small>mdi-plus</v-icon>
                            <v-icon small style="margin-left: -8px">mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <columns-menu v-on:add="addLast" />
                </v-menu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ColumnsMenu from '../components/ColumnsMenu.vue';
//import Draggable from 'vuedraggable';
import components from '../component.js'
export default {
    name: 'zoezi-rowlayout',

    zoezi: {
        title: 'Row layout',
        icon: 'mdi-view-quilt'
    },

    components: {
        ColumnsMenu,
        //      Draggable,
    },

    props: {
        rows: {
            title: 'Rows',
            type: Array,
            fulltype: 'componentlist',
            typeinfo: {
                component: 'zoezi-row'
            },
            default: () => []
        }
    },
    data: () => ({
        renderKey: 0
    }),
    methods: {
        save() {
            while (this.rows.find(row => !row || row.length == 0)) {
                let index = this.rows.findIndex(row => !row || row.length == 0);
                this.rows.splice(index, 1);
            }
            this.$emit('save', {rows: this.rows});
            this.renderKey++;
        },
        removeRow(rowindex) {
            this.rows.splice(rowindex, 1);
            this.save();
        },
        addAbove(rowindex, newrow) {
            this.rows.splice(rowindex, 0, newrow);
            this.save();
            components.selectComponent(newrow.props.columns[0].id);
        },
        addBelow(rowindex, newrow) {
            this.rows.splice(rowindex+1, 0, newrow);
            this.save();
            components.selectComponent(newrow.props.columns[0].id);
        },
        addLast(newrow) {
            this.rows.splice(this.rows.length, 0, newrow);
            this.save();
            components.selectComponent(newrow.props.columns[0].id);
        }
    },

    created() {
        // FIXME - this is just migration code from old row layout style to the new row layout style

        let newrows;

        this.rows.forEach(row => {
            if (Array.isArray(row)) {
                if (!newrows) {
                    newrows = [];
                }
                let newrow = {component: 'zoezi-row', props: {columns: []}}
                newrow.props.columns = row.map(columnConfig => {
                    let col = Object.assign({}, columnConfig);
                    delete col.width;
                    let config = {component: 'zoezi-column', props: {cols: columnConfig.width, component: components.makeEmptyConfig(col)}};
                    return config;
                })
                newrows.push(newrow);
            }
        });

        if (newrows) {
            this.$parent.config.props.rows = newrows;
        }
    }
}
</script>
